import { NgModule } from "@angular/core";
import { DataCyDirective } from "./directives/data-cy.directive";

/**
 * Module that provides test-related directives for Cypress component testing.
 *
 * Import this module in any standalone component that uses `data-cy` attributes
 * to ensure the attributes are stripped in production builds.
 *
 * Usage:
 * ```typescript
 * @Component({
 *   standalone: true,
 *   imports: [TestSelectorsModule],
 * })
 * ```
 */
@NgModule({
  imports: [DataCyDirective],
  exports: [DataCyDirective],
})
export class TestSelectorsModule {}
